$( document ).ready(function() {
  
    
      var platform = navigator.platform.toLowerCase();
      
      if (platform.indexOf('win') > -1) {
        $('body').addClass('windows');
      } else if (platform.indexOf('mac') > -1) {
        $('body').addClass('mac');
      } else if (platform.indexOf('linux') > -1) {
        $('body').addClass('linux');
      }
    
$(window).scroll(function() {
    var scroll = $(window).scrollTop();
    if (scroll >= 500) {
        $(".scroll-to-top-btn").addClass("visible");
    } else {
        $(".scroll-to-top-btn").removeClass("visible");
    }
});

  $(".scroll-to-top-btn").click(function() {
  $("html, body").animate({ scrollTop: 0 }, "slow");
  return false;
});
  
$(".icon-video").click(function(){
$("#use_video").trigger('play');
$(this).hide();
});
$("#use_video").click(function(){
$("#use_video").trigger('pause');
$(".icon-video").show();
});


// $(".details-product .details-cstm").each(function(){
// $(this).click(function(){
// $(this).toggleClass('active');
//     });
//     });

$('.details-cstm').on('click', function () {
    $('.details-product').toggleClass('active')
});


$('.icon-video').on('click', function () {
    $('.left-video-area').addClass('removeImg')
});


// $('.product-img.slider-product').slick({
//   arrow: true,
//   infinite: true,
//   speed: 300,
//   slidesToShow: 3,
//   slidesToScroll: 1,
//   responsive: [
//     {
//       breakpoint: 1024,
//       settings: {
//         slidesToShow: 3,
//         slidesToScroll: 1,
//         infinite: true,
//         dots: true
//       }
//     },
//     {
//       breakpoint: 600,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 1
//       }
//     },
//     {
//       breakpoint: 480,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1
//       }
//     }
//     // You can unslick at a given breakpoint now by adding:
//     // settings: "unslick"
//     // instead of a settings object
//   ]
// });


// Initialize Slick slider for mobile view only
function handleSlider() {
  if ($(window).width() <= 750) {
    if (!$('.product-img.slider-product').hasClass('slick-initialized')) {
      $('.product-img.slider-product').slick({
        arrows: true,
        infinite: true,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 750,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
              dots: true
            }
          }
        ]
      });
    }
  } else {
    if ($('.product-img.slider-product').hasClass('slick-initialized')) {
      $('.product-img.slider-product').slick('unslick');
    }
  }
}

// Run on load
handleSlider();

// Run on resize
$(window).on('resize', function () {
  handleSlider();
});



var track = document.getElementById('track');

var controlBtn = document.getElementById('play-pause');

function playPause() {
    if (track.paused) {
        track.play();
        //controlBtn.textContent = "Pause";
        controlBtn.className = "play";
    } else { 
        track.pause();
         //controlBtn.textContent = "Play";
        controlBtn.className = "pause";
    }
}

controlBtn.addEventListener("click", playPause);
track.addEventListener("ended", function() {
  controlBtn.className = "play";
});






// video-jquery

const videoElement = document.querySelector('video');
const playPauseButton = document.querySelector('button');

playPauseButton.addEventListener('click', () => {
	playPauseButton.classList.toggle('playing');
	if (playPauseButton.classList.contains('playing')) {
		videoElement.play();
	}
	else {
		videoElement.pause();
	}
});

videoElement.addEventListener('ended', () => {
	playPauseButton.classList.remove('playing');
});


  

});
$(document).ready(function() {
    // Get the text content of the h1 tag within the product__title div
    var productTitle = $('.product__title h1').text();

    // Loop through each li element and check if the class matches the product title
    $('.product-grid li').each(function() {
        if ($(this).hasClass(productTitle)) {
            $(this).css('display','none');
        }
    });


$("ul.tmenu_nav").hover(function() {
  $('header.header').toggleClass('active');
});


});

$(document).ready(function () {
  // Create a wrapper div element for both the quantity form and the product form (buy button section)
  var wrapperDiv = $('<div class="product-form-wrapper"></div>');
  
  // Select the quantity form and the product form (buy button) and wrap them in the same wrapper div
  $('.product-form__input.product-form__quantity').add('.product-form').wrapAll(wrapperDiv);
});

